/* eslint-disable */
import store from "../../store/index";
import axios from "axios";
import { data } from "jquery";
import moment from "moment";
export default {
  props: { userid: String },
  data() {
    return {
      baseUrl: `${process.env.VUE_APP_Service_URL}/management/site/`,
      baseapi: process.env.VUE_APP_Service_URL,
      defaultdate: "",
      defaultTime: "",
      disableStatus: true,
      value: {
        studyId: "",
        siteCode: "",
        siteName: "",
        piContactDetails: {
          name:"",
          role :"",
          email: "",
          phone: "",
          address: ""
        },
        subInvestigator: {
          name:"",
          role :"",
          email: "",
          phone: "",
          address: ""
        },
        siteAddress: {
          street: "",
          city: "",
          state:"",
          country: "",
          postalCode: ""
        },
        institutionName: "",
        department: "",
        primarySiteContact: "",
        siteContactInfo: {
          phone: "",
          fax: "",
          email: "",
          emergencyContact: ""
        },
        irbName: "",
        irbReferenceNo: "",
        submissionDate: null,
        regulatoryAuthorityApproval: null,
        renewalDate: null,
        currentStatus: "",
        statusEffectiveDate: null,
        sivDate: null,
        actualSIVDate: null,
        activationDate: null,
        targetnrollment: 0,
        actualEnrollment: 0,
        screeenFailureTracking: "",
        dropoutTracking: "",
        budjetstatus: "",
        monitoringPlan: "",
        lastmonitoringVisitDate: null,
        nextMonitoringVisitPlannedDate: null,
        siteCRA: "",
        siteStartupSpecialList: "",
        closeoutVisitDate: null,
        archivalStatus: "",
        active: true,
        language: "",
        languageCode: "",
        siteNotes: ""
      },

      editValue : {
        siteID: "",
        accountId: "",
        active: true,
        studyId: "",
        studyRef: null,
        siteCode: "",
        siteName: "",
        piContactDetails: {
          name:"",
          role :"",
          email: "",
          phone: "",
          address: ""
        },
        subInvestigator: {
          name:"",
          role :"",
          email: "",
          phone: "",
          address: ""
        },
        siteAddress: {
          street: "",
          city: "",
          state: "",
          country: "",
          postalCode: ""
        },
        institutionName: "",
        department: "",
        primarySiteContact: "",
       siteContactInfo: {
          phone: "",
          fax: "",
          email: "",
          emergencyContact: ""
        },
        irbName: "",
        irbReferenceNo: "",
        submissionDate: null,
        regulatoryAuthorityApproval: null,
        renewalDate: null,
        currentStatus: "",
        statusEffectiveDate: null,
        plannedSIVDate: null,
        actualSIVDate: null,
        activationDate: null,
        targetnrollment: 0,
        actualEnrollment: 0,
        screeenFailureTracking: "",
        dropoutTracking: "",
        budjetstatus: "",
        monitoringPlan: "",
        lastmonitoringVisitDate: null,
        nextMonitoringVisitPlannedDate: null,
        siteCRA: "",
        siteStartupSpecialList: "",
        closeoutVisitDate: null,
        archivalStatus: "",
        language: "",
        languageCode: "",
        siteNotes: ""
      },

      idToken: "",
      headerValues: {},
      languages: [],
      errors: [false, false, false, false, false, false, false],

      // Section state for collapsible functionality
      sectionState: {
        siteIdentification: true,
        siteAddress: true,
        regulatory: false,
        siteStatus: false,
        enrollment: false,
        operational: false,
        closeOut: false
      },
      roleList: [],
      investigators: {},
      userList: [],
      subInvestigators:[],
      countries: []
    };
  },
  async mounted() {
    this.value.language = "English"
    this.defaultdate = localStorage.getItem("dateformat");
    this.defaultTime= localStorage.getItem("timeformat"),
    this.idToken = store.getters.getIdToken;
    this.headerValues = {
      headers: {
        Authorization: "Bearer " + this.idToken,
        "Content-Type": "application/json",
      },
    };

    this.errors[6] = false;
    this.idToken = await store.getters.getIdToken;
    this.headerValues = {
      headers: {
        Authorization: "Bearer " + this.idToken,
        "Content-Type": "application/json",
      },
    };
    this.setRoleList();
    if (this.userid !== "0") {
      await this.getSite(this.userid);
      this.disableStatus = true;
      await this.setValues();
      await this.getSubInvestigators();
      await this.getRoleBasedUserlist();
    } else {
      console.log("will set disabled status to false");
      this.disableStatus = false;
    }
    this.getLanguage();
    await this.getCountries();
  },
  methods: {
    // Toggle section visibility
    toggleSection(section) {
      this.sectionState[section] = !this.sectionState[section];
    },
    async clearEditValues() {
      this.errors[6] = false;
      // --- clear editValue ---
      //this.editValue.siteID = "";
      this.editValue.accountId = "e75456d6-710d-4ad0-9eb7-2293623f889a";
      this.editValue.active = true;
      //this.editValue.studyId = store.getters.getStudyIs;
      this.editValue.studyRef = null;
      //this.editValue.siteCode = "";
      this.editValue.siteName = "";
      this.editValue.piContactDetails.name = "";
      this.editValue.piContactDetails.role = "";
      this.editValue.piContactDetails.email = "";
      this.editValue.piContactDetails.phone = "";
      this.editValue.piContactDetails.address = "";
      this.editValue.subInvestigator = {
          name:"",
          role :"",
          email: "",
          phone: "",
          address: ""
      };
      this.editValue.siteAddress.street = "";
      this.editValue.siteAddress.city = "";
      this.editValue.siteAddress.state = "";
      this.editValue.siteAddress.country = "";
      this.editValue.siteAddress.postalCode = "";
      this.editValue.institutionName = "";
      this.editValue.department = "";
      this.editValue.primarySiteContact = "";
      this.editValue.siteContactInfo =  {
          phone: "",
          fax: "",
          email: "",
          emergencyContact: ""
      };
      this.editValue.irbName = "";
      this.editValue.irbReferenceNo = "";
      this.editValue.submissionDate = null;
      this.editValue.regulatoryAuthorityApproval = null;
      this.editValue.renewalDate = null;
      this.editValue.currentStatus = "";
      this.editValue.statusEffectiveDate = null;
      this.editValue.plannedSIVDate = null;
      this.editValue.actualSIVDate = null;
      this.editValue.activationDate = null;
      this.editValue.targetnrollment = 0;
      this.editValue.actualEnrollment = 0;
      this.editValue.screeenFailureTracking = "";
      this.editValue.dropoutTracking = "";
      this.editValue.budjetstatus = "";
      this.editValue.monitoringPlan = "";
      this.editValue.lastmonitoringVisitDate = null;
      this.editValue.nextMonitoringVisitPlannedDate = null;
      this.editValue.siteCRA = "";
      this.editValue.siteStartupSpecialList = "";
      this.editValue.closeoutVisitDate = null;
      this.editValue.archivalStatus = "";
      this.editValue.language = "";
      this.editValue.languageCode = "";
      this.editValue.siteNotes = "";

      // --- clear value ---
      //this.value.studyId = store.getters.getStudyIs;
      //this.value.siteCode = "";
      this.value.siteName = "";
      this.value.piContactDetails.name = "";
      this.value.piContactDetails.role = "";
      this.value.piContactDetails.email = "";
      this.value.piContactDetails.phone = "";
      this.value.piContactDetails.address = "";
      this.value.subInvestigator = {
          name:"",
          role :"",
          email: "",
          phone: "",
          address: ""
      };
      this.value.siteAddress.street = "";
      this.value.siteAddress.city = "";
      this.value.siteAddress.state = "";
      this.value.siteAddress.country = "";
      this.value.siteAddress.postalCode = "";
      this.value.institutionName = "";
      this.value.department = "";
      this.value.primarySiteContact = "";
      this.value.siteContactInfo.phone = "";
      this.value.siteContactInfo.fax = "";
      this.value.siteContactInfo.email = "";
      this.value.siteContactInfo.emergencyContact = "";
      this.value.irbName = "";
      this.value.irbReferenceNo = "";
      this.value.submissionDate = null;
      this.value.regulatoryAuthorityApproval = null;
      this.value.renewalDate = null;
      this.value.currentStatus = "";
      this.value.statusEffectiveDate = null;
      this.value.sivDate = null;
      this.value.actualSIVDate = null;
      this.value.activationDate = null;
      this.value.targetnrollment = 0;
      this.value.actualEnrollment = 0;
      this.value.screeenFailureTracking = "";
      this.value.dropoutTracking = "";
      this.value.budjetstatus = "";
      this.value.monitoringPlan = "";
      this.value.lastmonitoringVisitDate = null;
      this.value.nextMonitoringVisitPlannedDate = null;
      this.value.siteCRA = "";
      this.value.siteStartupSpecialList = "";
      this.value.closeoutVisitDate = null;
      this.value.archivalStatus = "";
      this.value.active = true;
      this.value.language = "";
      this.value.languageCode = "";
      this.value.siteNotes = "";
    },

    async clearValues() {
      this.errors[6] = false;

      //this.value.studyId = "";
      //this.value.siteCode = "";
      this.value.siteName = "";
      this.value.piContactDetails = {
        name:"",
        role :"",
        email: "",
        phone: "",
        address: ""
      };
      this.value.subInvestigator = {
        name:"",
        role :"",
        email: "",
        phone: "",
        address: ""
      };
      this.value.siteAddress = {
        street: "",
        city: "",
        state: "",
        country: "",
        postalCode: ""
      };
      this.value.institutionName = "";
      this.value.department = "";
      this.value.primarySiteContact = "";
      this.value.siteContactInfo = {
        phone: "",
        fax: "",
        email: "",
        emergencyContact: ""
      };
      this.value.irbName = "";
      this.value.irbReferenceNo = "";
      this.value.submissionDate = null;
      this.value.regulatoryAuthorityApproval = null;
      this.value.renewalDate = null;
      this.value.currentStatus = "";
      this.value.statusEffectiveDate = null;
      this.value.sivDate = null;
      this.value.actualSIVDate = null;
      this.value.activationDate = null;
      this.value.targetnrollment = 0;
      this.value.actualEnrollment = 0;
      this.value.screeenFailureTracking = "";
      this.value.dropoutTracking = "";
      this.value.budjetstatus = "";
      this.value.monitoringPlan = "";
      this.value.lastmonitoringVisitDate = null;
      this.value.nextMonitoringVisitPlannedDate = null;
      this.value.siteCRA = "";
      this.value.siteStartupSpecialList = "";
      this.value.closeoutVisitDate = null;
      this.value.archivalStatus = "";
      this.value.active = true;
      this.value.language = "";
      this.value.languageCode = "";
      this.value.siteNotes = "";
    },

    ValidateAll() {
        //this.value.siteCode = this.value.siteCode.replace(/^\s*/, "");
        this.value.siteCode = this.value.siteCode.replace(/ +/g, ' ').trim();
        this.value.siteName = this.value.siteName.replace(/ +/g, ' ').trim();
        // this.value.siteContactName = this.value.siteContactName.replace(/ +/g, ' ').trim();
        // this.value.siteContactEmail = this.value.siteContactEmail.replace(/ +/g, ' ').trim();
        // this.value.siteNotes = this.value.siteNotes.replace(/ +/g, ' ').trim();
        // this.value.numberOfPatient = this.value.numberOfPatient.toString().replace(/\s/g, '')    
        // this.value.numberOfPatient=+this.value.numberOfPatient   
      //Number of payients
      // if(this.value.siteContactEmail){
      //     if (this.value.siteContactEmail.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/)) {
      //     this.errors[1]=false
      //     } else {
      //       this.errors[1]=true
      //     }
      // }
      if (this.value.siteCode == "") {
        this.errors[0] = true;
      } else {
        this.errors[0] = false;
      }
       if (this.value.siteName == "") {
        this.errors[1] = true;
      } else {
        this.errors[1] = false;
      }
    },
    setEditValues() {
        this.editValue.siteID = this.value.siteID;
        this.editValue.accountId = this.value.accountId;
        this.editValue.active = this.value.active;
        this.editValue.studyId = this.value.studyId;
        this.editValue.studyRef = this.value.studyRef;
        this.editValue.siteCode = this.value.siteCode;
        this.editValue.siteName = this.value.siteName;

        this.editValue.piContactDetails.name = this.value.piContactDetails.name;
        this.editValue.piContactDetails.role = this.value.piContactDetails.role;
        this.editValue.piContactDetails.email = this.value.piContactDetails.email;
        this.editValue.piContactDetails.phone = this.value.piContactDetails.phone;
        this.editValue.piContactDetails.address = this.value.piContactDetails.address;

        this.editValue.subInvestigator.name = this.value.subInvestigator.name;
        this.editValue.subInvestigator.role = this.value.subInvestigator.role;
        this.editValue.subInvestigator.email = this.value.subInvestigator.email;

        this.editValue.siteAddress.street = this.value.siteAddress.street;
        this.editValue.siteAddress.city = this.value.siteAddress.city;
        this.editValue.siteAddress.state = this.value.siteAddress.state;
        this.editValue.siteAddress.country = this.value.siteAddress.country;
        this.editValue.siteAddress.postalCode = this.value.siteAddress.postalCode;

        this.editValue.institutionName = this.value.institutionName;
        this.editValue.department = this.value.department;
        this.editValue.primarySiteContact = this.value.primarySiteContact;

        if (this.value.siteContactInfo) {
          this.editValue.siteContactInfo = {
            phone: this.value.siteContactInfo.phone,
            fax: this.value.siteContactInfo.fax,
            email: this.value.siteContactInfo.email,
            emergencyContact: this.value.siteContactInfo.emergencyContact
          };
        } else {
          this.editValue.siteContactInfo ={
            phone: "",
            fax: "",
            email: "",
            emergencyContact: ""
          };
        }

        this.editValue.irbName = this.value.irbName;
        this.editValue.irbReferenceNo = this.value.irbReferenceNo;
        this.editValue.currentStatus = this.value.currentStatus;
        this.editValue.targetnrollment = this.value.targetnrollment;
        this.editValue.actualEnrollment = this.value.actualEnrollment;
        this.editValue.screeenFailureTracking = this.value.screeenFailureTracking;
        this.editValue.dropoutTracking = this.value.dropoutTracking;
        this.editValue.budjetstatus = this.value.budjetstatus;
        this.editValue.monitoringPlan = this.value.monitoringPlan;
        this.editValue.siteCRA = this.value.siteCRA;
        this.editValue.siteStartupSpecialList = this.value.siteStartupSpecialList;
        this.editValue.archivalStatus = this.value.archivalStatus;
        this.editValue.language = this.value.language;
        this.editValue.languageCode = this.value.languageCode;
        this.editValue.siteNotes = this.value.siteNotes;

        this.editValue.closeoutVisitDate = this.filterDate(this.value.closeoutVisitDate);
        this.editValue.renewalDate = this.filterDate(this.value.renewalDate);
        this.editValue.actualSIVDate = this.filterDate(this.value.actualSIVDate);
        this.editValue.submissionDate = this.filterDate(this.value.submissionDate);
        this.editValue.plannedSIVDate = this.filterDate(this.value.plannedSIVDate); 
        this.editValue.statusEffectiveDate = this.filterDate(this.value.statusEffectiveDate);
        this.editValue.activationDate = this.filterDate(this.value.activationDate);
        this.editValue.lastmonitoringVisitDate = this.filterDate(this.value.lastmonitoringVisitDate);
        this.editValue.regulatoryAuthorityApproval = this.filterDate(this.value.regulatoryAuthorityApproval);
        this.editValue.nextMonitoringVisitPlannedDate = this.filterDate(this.value.nextMonitoringVisitPlannedDate);
        
        
        
        

        if (this.value.language) {
        this.languages.filter((item) => {
          if (this.value.language == item.language) {
            this.editValue.languageCode = item.code
          }
        });
      }
    },
    setValues() {
      this.value.siteID = this.editValue.siteID;
      this.value.accountId = this.editValue.accountId;
      this.value.active = this.editValue.active;
      this.value.studyId = this.editValue.studyId;
      this.value.studyRef = this.editValue.studyRef;
      this.value.siteCode = this.editValue.siteCode;
      this.value.siteName = this.editValue.siteName;

      this.value.piContactDetails.name = this.editValue.piContactDetails.name;
      this.value.piContactDetails.role = this.editValue.piContactDetails.role;
      this.value.piContactDetails.email = this.editValue.piContactDetails.email;
      this.value.piContactDetails.phone = this.editValue.piContactDetails.phone;
      this.value.piContactDetails.address = this.editValue.piContactDetails.address;

      this.value.subInvestigator.role = this.editValue.subInvestigator.role;
      this.value.subInvestigator.name = this.editValue.subInvestigator.name;
      this.value.subInvestigator.email = this.editValue.subInvestigator.email;
      this.value.subInvestigator.phone = this.editValue.subInvestigator.phone;
      this.value.subInvestigator.address = this.editValue.subInvestigator.address;

      this.value.siteAddress.street = this.editValue.siteAddress.street;
      this.value.siteAddress.city = this.editValue.siteAddress.city;
      this.value.siteAddress.state = this.editValue.siteAddress.state;
      this.value.siteAddress.country = this.editValue.siteAddress.country;
      this.value.siteAddress.postalCode = this.editValue.siteAddress.postalCode;

      this.value.institutionName = this.editValue.institutionName;
      this.value.department = this.editValue.department;
      this.value.primarySiteContact = this.editValue.primarySiteContact;

      if (this.editValue.siteContactInfo) {
        this.value.siteContactInfo = {
          phone: this.editValue.siteContactInfo.phone,
          fax: this.editValue.siteContactInfo.fax,
          email: this.editValue.siteContactInfo.email,
          emergencyContact: this.editValue.siteContactInfo.emergencyContact
        };
      } else {
        this.value.siteContactInfo = {
          phone: "",
          fax: "",
          email: "",
          emergencyContact: ""
        };
      }

      this.value.irbName = this.editValue.irbName;
      this.value.irbReferenceNo = this.editValue.irbReferenceNo;
      this.value.currentStatus = this.editValue.currentStatus;
      this.value.regulatoryAuthorityApproval = this.toDatePickerFormat(this.editValue.regulatoryAuthorityApproval);
      this.value.submissionDate = this.toDatePickerFormat(this.editValue.submissionDate);
      this.value.renewalDate =  this.toDatePickerFormat(this.editValue.renewalDate);
      this.value.statusEffectiveDate = this.toDatePickerFormat(this.editValue.statusEffectiveDate);
      this.value.plannedSIVDate = this.toDatePickerFormat(this.editValue.plannedSIVDate);
      this.value.actualSIVDate =  this.toDatePickerFormat(this.editValue.actualSIVDate);
      this.value.activationDate =  this.toDatePickerFormat(this.editValue.activationDate);
      this.value.lastmonitoringVisitDate = this.toDatePickerFormat(this.editValue.lastmonitoringVisitDate);
      this.value.nextMonitoringVisitPlannedDate = this.toDatePickerFormat(this.editValue.nextMonitoringVisitPlannedDate);
      this.value.closeoutVisitDate = this.toDatePickerFormat(this.editValue.closeoutVisitDate);
      this.value.targetnrollment = this.editValue.targetnrollment;
      this.value.actualEnrollment = this.editValue.actualEnrollment;
      this.value.screeenFailureTracking = this.editValue.screeenFailureTracking;
      this.value.dropoutTracking = this.editValue.dropoutTracking;
      this.value.budjetstatus = this.editValue.budjetstatus;
      this.value.monitoringPlan = this.editValue.monitoringPlan;
      this.value.siteCRA = this.editValue.siteCRA;
      this.value.siteStartupSpecialList = this.editValue.siteStartupSpecialList;
      this.value.archivalStatus = this.editValue.archivalStatus;
      this.value.language = this.editValue.language;
      this.value.languageCode = this.editValue.languageCode;
      this.value.siteNotes = this.editValue.siteNotes;

      if (this.editValue.language) {
        this.languages.filter((item) => {
          if (this.value.language == item.language) {
            this.value.languageCode = item.code
          }
        });
      }
      console.log("Values Set");
      console.log(this.value);
    },
    async createSite() {
      this.value.status = "New";
      const valnow = store.getters.getStudyIs;
      if (this.value.language) {
        this.languages.filter((item) => {
          if (this.value.language == item.language) {
            this.value.languageCode = item.code
          }
        });
      }
      this.value.studyId = store.getters.getStudyIs;
      if(valnow == "" | valnow == null ){
        alert(this.$t('navigations.please select a study'));
      }
      else {
      await axios
       //.put("https://localhost:5001/site/update", this.editValue, this.headerValues)
        .post(this.baseUrl + "create", this.value, this.headerValues)
        .then((res) => {
          console.log(res);
          alert(this.$t('navigations.site created successfully'));
          this.$router.push(`/sitelist`);
        })
        .catch((err) => {
           if (err.response.data.detail == "Site code already exists")             
           {
            alert(this.$t('navigations.site code already exists'));
           }
        });
      }
    },
    async editSite() {
      console.log(this.editValue);

      await axios
        .put(this.baseUrl + "update", this.editValue, this.headerValues)
       // .put("https://localhost:5001/site/update", this.editValue, this.headerValues)
        .then((res) => {
         alert(this.$t('navigations.site updated successfully'));
         this.$router.push(`/sitelist`);
        })
       .catch((err) => {
           if (err.response.data.detail == "Site code already exists.")             
           {
            alert(this.$t('navigations.site code already exists'));
           }
        });
    },
    async getSite(id) {
      await axios
        .get(this.baseUrl + "getbyid?id=" + id, this.headerValues)
        .then((res) => {
          this.editValue = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async onclosed() {
      await this.$router.push(`/sitelist`);
    },
    async save() {
      this.ValidateAll();
      if (
        !this.errors[0] &&
        !this.errors[1] 
        // !this.errors[2] &&
        // !this.errors[3] &&
        // !this.errors[4]
      ) {
        if (this.userid === "0") {
          await this.createSite().then(() => {
          });
        } else {
          this.setEditValues();
          await this.editSite()
            .then((res) => {
            })
            .catch((err) => {
              alert(this.$t('navigations.something went wrong.'));
            });
        }
      }
    },
    async  clear() {
      if(this.userid === "0"){
        this.clearValues();
      }
      else{
        this.clearEditValues();
      }
    },
     async numberonlyvalidation(fieldname){
       //let isNumber = Number(this.values[fieldname])?true:false;
       let isNumber=true;
       this.value[fieldname] = this.value[fieldname].replace(/\s/g, '');
       let fieldval = this.value[fieldname];
       console.log("valtttttt is",fieldval);
       if(fieldval % 1 != 0)
       {
        isNumber = false;
       }
      console.log(this.value[fieldname]);
      console.log(isNumber);
      if(!isNumber){
        this.value[fieldname] = 0;
      
       }
       else{
         if(parseInt(this.value[fieldname]) >= 0){
         
         }
         else{
          this.value[fieldname] = 0;

         }
        
       }
    },
     async getLanguage() {
          const idtoken = store.getters.getIdToken;
          await axios
            .get(`${this.baseapi}/forms/template/languages`, {
              headers: {
                Authorization: "Bearer " + idtoken,
                "Content-Type": "application/json",
              },
            })
            .then((res) => {
    
              this.languages = res.data;
            })
            .catch((err) => {
              console.log(err);
            });
    },
    async setRoleList() {
            const idtoken = store.getters.getIdToken;
             axios
                .get(
                `${this.baseapi}/account-core/roles/rolelist`,
                {
                    headers: {
                    Authorization: "Bearer " + idtoken,
                    "Content-Type": "application/json",
                    },
                }
                ).then((res) => {
                    this.roleList = res.data;
                })
    },
    async getRoleBasedUserlist(){
      this.userList=[];
            const idtoken = store.getters.getIdToken;
            if(this.value.piContactDetails.role != null && this.value.piContactDetails.role != ""){
                axios
                .get(
                `${this.baseapi}/account-core/user/getusersbyrole?roleids=${this.value.piContactDetails.role}&&studyid=${store.getters.getStudyIs}`,{
                headers: {
                    Authorization: "Bearer " + idtoken,
                    "Content-Type": "application/json",
                },
                })
                .then((res) => {
                    if(Array.isArray(res.data) && res.data.length > 0){
                        this.userList = res.data 
                    }
                    else{
                        this.userList=[]
                    }
                    
                })
                .catch((err) => {
                    console.log(err);
                });
            }
            else{
                this.userList =[];
            }
    },
    async changePIRole(){
       this.value.piContactDetails = {
          name:"",
          role :this.value.piContactDetails.role,
          email: "",
          phone: "",
          address: ""
      },
      this.editValue.piContactDetails = {
          name:"",
          role :this.value.piContactDetails.role,
          email: "",
          phone: "",
          address: ""
      }
      await this.getRoleBasedUserlist();
    },
    async getSubInvestigators() {
      this.subInvestigators=[];
            const idtoken = store.getters.getIdToken;
            if(this.value.subInvestigator.role != null && this.value.subInvestigator.role != ""){
                axios
                .get(
                `${this.baseapi}/account-core/user/getusersbyrole?roleids=${this.value.subInvestigator.role}&&studyid=${store.getters.getStudyIs}`,{
                headers: {
                    Authorization: "Bearer " + idtoken,
                    "Content-Type": "application/json",
                },
                })
                .then((res) => {
                    if(Array.isArray(res.data) && res.data.length > 0){
                        this.subInvestigators = res.data 
                    }
                    else{
                        this.subInvestigators=[]
                    }
                    
                })
                .catch((err) => {
                    console.log(err);
                });
            }
            else{
                this.subInvestigators =[];
            }
    },
    async subInvestigatorChange(){
       this.value.subInvestigator = {
          name:"",
          role :this.value.subInvestigator.role,
          email: "",
          phone: "",
          address: ""
      },
      this.editValue.subInvestigator = {
          name:"",
          role :this.value.subInvestigator.role,
          email: "",
          phone: "",
          address: ""
      }
      await this.getSubInvestigators();
    },
    subInvestigatorSelected(event) {
        const selectedEmail = event.target.value;
        const user = this.subInvestigators.find(u => u.email === selectedEmail);
        if (user) {
          this.value.subInvestigator.email = user.email;
          this.value.subInvestigator.name = user.name;
        }
    },
    userSelected(event) {
      const selectedEmail = event.target.value
      const user = this.userList.find(u => u.email === selectedEmail)
      if (user) {
        this.value.piContactDetails.email = user.email
        this.value.piContactDetails.name = user.name
      }
    },
    filter(data) {
      if (data) {
        return moment(data).format(this.defaultdate);
      }
    },
   filterDate(data) {
      if (!data) {
        return null;
      }
      return moment(data).utc().format("YYYY-MM-DDTHH:mm:ss[Z]");
    },
    toDatePickerFormat(dateString) {
      if(!dateString){
        return null;
      }
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // months are 0-based
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  },
   async getCountries() {
      try {
        const idtoken = store.getters.getIdToken;
        const res = await axios.get(`${this.baseapi}/management/country/getcountrieswithlanguage`, {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        });
        this.countries = res.data;
      } catch (error) {
        console.error("Error fetching all countries:", error);
      }
    }
  },
};